const getRootElement = (): HTMLElement | null => {
  const craRootElement = document.getElementById('root');
  const nextRootElement = document.getElementById('__next');
  return craRootElement || nextRootElement;
};

export default getRootElement;
